import Settings from './Settings.page';

export default Settings;